/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchListElementList = {
    type: 'array',
    contains: {
        type: 'MatchListElement',
    },
} as const;
